import React from 'react'
import {Link as RouterLink, Route, Switch, useLocation} from 'react-router-dom'
import {Routes} from '../../common/Routes'
import {isActivePath} from '../../common/utils/isActivePath'
import {Box} from '../../webui/Box'
import {Container} from '../../webui/Container'
import {Link} from '../../webui/Link'
import {PublicStatisticsPage} from './PublicStatisticsPage'
import {StatisticsProductsPage} from './StatisticsProductsPage'
import {StatisticsRentalsPage} from './StatisticsRentalsPage'
import {StatisticsUsersPage} from './StatisticsUsersPage'

interface Props {}

const StatsNavLink: React.FC<{to: string; children: React.ReactNode}> = ({to, children}) => {
  const {pathname} = useLocation()
  const active = isActivePath(pathname, to)
  return (
    <Link component={RouterLink} to={to} color={active ? 'textPrimary' : undefined} sx={{fontWeight: active ? 'bold' : 'normal'}}>
      {children}
    </Link>
  )
}

export const StatisticsPage: React.FC<Props> = () => {
  return (
    <Container>
      <Box m={2} display={'flex'}>
        <StatsNavLink to={Routes.STATISTICS_RENTALS}>Rentals</StatsNavLink>
        <Box ml={2} />
        <StatsNavLink to={Routes.STATISTICS_PRODUCTS}>Products</StatsNavLink>
        <Box ml={2} />
        <StatsNavLink to={Routes.STATISTICS_USERS}>Users</StatsNavLink>
        <Box ml={2} />
        <StatsNavLink to={Routes.STATISTICS_PUBLIC}>For customers</StatsNavLink>
      </Box>
      <Switch>
        <Route path={Routes.STATISTICS_RENTALS}>
          <StatisticsRentalsPage />
        </Route>
        <Route path={Routes.STATISTICS_PRODUCTS}>
          <StatisticsProductsPage />
        </Route>
        <Route path={Routes.STATISTICS_USERS}>
          <StatisticsUsersPage />
        </Route>
        <Route path={Routes.STATISTICS_PUBLIC}>
          <PublicStatisticsPage />
        </Route>
      </Switch>
    </Container>
  )
}
